import ApsModels from "../../../models";
import fetcher from "../Fetcher";

class NFIRSWildlandPropertyService {
  get = async (id: any) => {
    const url = `/api/NfirsWildlandProperty/${id}`;
    return fetcher.get<ApsModels.INfirsWildlandPropertyOutputDto>(url);
  };

  update = async (data: ApsModels.INfirsWildlandPropertyInputDto) => {
    const url = `/api/NfirsWildlandProperty`;
    return fetcher.post<ApsModels.INfirsWildlandPropertyOutputDto>(url, data);
  };
}

const nfirsWildlandProperty = new NFIRSWildlandPropertyService();
export default nfirsWildlandProperty;
